export default { sha: '805bbc5e0b9489f06c4c21b14fecdd97412fe024', buildNumber: 'undefined' }
